import { css } from '@emotion/core';
import styled from '@emotion/styled';
import costco from '../../../images/sesame-costco.jpg';

const wrapperStyles = ({
  theme: {
    work,
    grid: { breakpoint },
  },
}) => css`
  background: ${work.sesameTertiary};
  padding: 0 15px 70px;
  margin: 0 -15px;
  position: relative;
  ${breakpoint.min730} {
    padding: 0;
    margin: auto;
    display: grid;
    min-height: 100vh;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    padding: 0;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 1500px;
      height: 100%;
      background-image: url(${costco});
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center right;
    }
  }
`;

const sectionStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  display: grid;
  row-gap: 0;

  ${breakpoint.fromPhoneMedium} {
    column-gap: 30px;
    row-gap: 0;
  }
  ${breakpoint.min730} {
    align-self: center;
    margin: 0 0 0 150px;
    grid-template-columns: 600px 1500px;
    column-gap: 150px;
  }
`;

const logosWrapperStyles = css`
  margin: 30px 0 20px;
`;

const imageWrapperStyles = ({
  theme: {
    grid: { breakpoint },
  },
}) => css`
  margin: 0 -15px;
  ${breakpoint.min730} {
    display: none;
  }
`;

/**
 * Component style declarations
 */
export const Wrapper = styled('div')(wrapperStyles);
export const Section = styled('div')(sectionStyles);
export const LogosWrapper = styled('div')(logosWrapperStyles);
export const ImageWrapper = styled('div')(imageWrapperStyles);
